import { ColumnDef } from '@tanstack/react-table'
import type { UpdateTask } from 'api/generated'
import { DataTableColumnHeader } from './data-table-column-header'
import { DataTableRowActions } from './data-table-row-actions'

// import { statuses } from '../data/data' // Decommenta se decidi di mostrare l'icona

export const columns: ColumnDef<UpdateTask>[] = [
  {
    accessorKey: 'id',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Task' />
    ),
    cell: ({ row }) => <div className='w-[60px]'>{row.getValue('id')}</div>,
    enableSorting: false,
    enableHiding: true,
  },
  {
    accessorKey: 'name',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Title' />
    ),
    cell: ({ row }) => {
      if (!row.original.name && !row.original.file) {
        return <div className='w-[80px]'></div>
      }
      let content = row.getValue('name') as string
      if (!row.getValue('name')) {
        content = row.original.file as string
      }

      return (
        <div
          className='flex cursor-help items-center space-x-2'
          title={content} // Tooltip nativo
        >
          <span className='block w-[150px] truncate font-medium sm:w-[250px] md:w-[350px] lg:w-[450px] xl:w-[500px]'>
            {content}
          </span>
        </div>
      )
    },
    filterFn: (row, id, value) => {
      if (row.getValue(id) === null) {
        return false
      }
      const cellValue = row.getValue(id) as string
      return cellValue.toLowerCase().includes(value.toLowerCase())
    },
  },

  // --- COLONNA STATUS ---
  // Re-inserita per mantenere intatta la logica dei filtri e delle azioni, ma nascosta visivamente
  {
    accessorKey: 'status',
    header: () => <div className='hidden' />, // Intestazione nascosta
    cell: () => <div className='hidden' />, // Contenuto nascosto
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id))
    },
    enableHiding: true,
  },

  {
    accessorKey: 'log',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Log' />
    ),
    cell: ({ row }) => {
      const logContent = row.getValue('log') as string
      if (!logContent) {
        return <div className='w-[80px]'>-</div>
      }

      return (
        <div className='flex cursor-help space-x-2' title={logContent}>
          {/* USIAMO max-w INVECE DI w */}
          <span className='block max-w-25 truncate font-medium sm:max-w-35 md:max-w-45 lg:max-w-60'>
            {logContent}
          </span>
        </div>
      )
    },
    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id))
    },
    enableSorting: false,
    enableHiding: true,
  },
  {
    accessorKey: 'upload_date',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Data upload' />
    ),
    cell: ({ row }) => {
      if (!row.getValue('upload_date')) {
        return <div className='w-[80px]'>-</div>
      }
      const date = new Date((row.getValue('upload_date') as number) * 1000)
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }
      const formattedDate = date.toLocaleDateString('it-IT', options)
      return <div className='w-[140px]'>{formattedDate}</div>
    },
    enableSorting: true,
    enableHiding: true,
  },
  {
    accessorKey: 'last_modification_date',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title='Ultima modifica' />
    ),
    cell: ({ row }) => {
      if (!row.getValue('last_modification_date')) {
        return <div className='w-[80px]'>-</div>
      }
      const date = new Date(
        (row.getValue('last_modification_date') as number) * 1000
      )
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }
      const formattedDate = date.toLocaleDateString('it-IT', options)
      return <div className='w-[140px]'>{formattedDate}</div>
    },
    enableSorting: true,
    enableHiding: true,
  },
  {
    id: 'actions',
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
]
